import { Modal } from '@/theme/index';
import { ContactOptions } from './ContactOptions/ContactOptions';

type TopicsType =
  | {
      name: string;
      display: string;
    }[]
  | null;

type ContactOptionsModalProps = {
  /** If true, the modal is open */
  isOpen: boolean;
  /** Uncontrolled function for changing the value of 'isOpen' */
  setIsOpen: (isOpen: boolean) => void;
  /** Function for opening the cancel confirmation modal */
  openConfirmCancelModal: (downsellTest?: boolean) => void;
  customTopics?: TopicsType;
  customBillingTopics?: TopicsType;
  validReportCountThreshold?: number;
  plansWithout5ReportBlocker?: string[];
  blockUpgradeWindowThreshold?: number;
};

export const ContactOptionsModal = ({
  isOpen,
  setIsOpen,
  openConfirmCancelModal,
  customTopics,
  customBillingTopics,
  plansWithout5ReportBlocker,
  validReportCountThreshold,
  blockUpgradeWindowThreshold,
}: ContactOptionsModalProps) => {
  return (
    <Modal
      open={isOpen}
      onClose={() => setIsOpen(false)}
      title="How can we help?"
      maxWidth={false}
      hasCloseIcon
    >
      <ContactOptions
        clickOrigin={null}
        setIsOpen={setIsOpen}
        openConfirmCancelModal={openConfirmCancelModal}
        customTopics={customTopics}
        customBillingTopics={customBillingTopics}
        plansWithout5ReportBlocker={plansWithout5ReportBlocker}
        validReportCountThreshold={validReportCountThreshold}
        blockUpgradeWindowThreshold={blockUpgradeWindowThreshold}
      />
    </Modal>
  );
};
